<template>
  <div class="d-flex overflow-auto">
    <div
      class="fences-grid"
      :style="{
        'grid-template-rows': `repeat(${rows}, ${cellSize}px)`,
        'grid-template-columns': `repeat(${columns}, ${cellSize}px)`,
      }"
    >
      <fences-cell
        v-for="cell in table"
        :key="`${cell.positiony}-${cell.positionx}`"
        :cell="cell"
        :cell-size="cellSize"
        :settings="settings"
      />
    </div>
  </div>
</template>

<script>
import FencesCell from './FencesCell.vue';

export default {
  name: 'FencesGrid',
  components: { FencesCell },
  props: {
    table: { type: Array, required: true },
    rows: { type: Number, required: true },
    columns: { type: Number, required: true },
    cellSize: { type: Number, default: 60 },
    settings: {
      type: Object,
      default: () => ({ colored: true }),
    },
  },
};
</script>

<style scoped>
.fences-grid {
  display: grid;
  width: fit-content;
  background-color: transparent;
  border: 2px solid #000;
  padding: 16px;
}
</style>
